import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/maximize.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args))),
    class: "border-0 bg-transparent p-0"
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: "Image"
    }, null, -1)
  ])))
}